import {makeTrackEvent} from './makeTrackEvent';

export type SettingAction = 'update template' | 'applied template';

export type TrackSettingProperties = {
  action: SettingAction;
  settings?: Record<any, any>;
};
export const trackWorkspaceTemplate = makeTrackEvent<
  TrackSettingProperties,
  {
    action: {
      description: 'what type of action was performed';
      exampleValues: ['update template', 'applied template'];
    };
    settings: {
      description: 'which settings were updated in the template';
      exampleValues: [undefined];
    };
    _description: 'Tracks events related to workspace Templates';
    _location: 'Customization happens on the workspace';
    _motivation: 'To track usage';
  }
>('Workspace Template');
